/**
 * Error boundary component for Next.js App Router.
 * Catches errors in the component tree and displays a fallback UI.
 *
 * Note: This is a client component ('use client') and must be in the app directory.
 * It catches errors in child components but not in itself or global-error.tsx.
 *
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/error
 */
'use client';

import { Button } from '@/components/ui/button';
import { ErrorPageLayout } from '@/components/error/error-page-layout';

export default function Error({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorPageLayout
      title="Something went wrong!"
      message="An unexpected error occurred."
      action={<Button onClick={reset}>Try again</Button>}
    />
  );
}
